<template lang="pug">
EcreativOrganismsPresentingLatestArticlesSliderAndCallToLearnMore(:articles="generatedData")
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { type ArticleModel, placeholderArticleModel } from 'data-types-config';
import EcreativOrganismsPresentingLatestArticlesSliderAndCallToLearnMore from '../organisms/PresentingLatestArticlesSliderAndCallToLearnMore.vue';

const props = defineProps({
  articleCount: {
    type: Number,
    default: 1,
  },
});

const defaultData: Partial<ArticleModel> = placeholderArticleModel;

const generatedData = computed(() => {
  return Array.from({ length: props.articleCount }, (_, index) => ({
    ...defaultData,
    index,
  }));
});
</script>
